/**
 * Preview-mode data for job-change suggestions (SC-13586).
 *
 * One pending company move and one already-resolved title question, so both the review dialog
 * and its resolved state can be built in Lovable without a backend. Keyed by suggestion id; the
 * person ids match nothing real on purpose — preview never navigates to them.
 */

import type { ContactChangeImpact, ContactChangeSuggestion } from "@/lib/hooks/use-contact-change-suggestion";

export const DUMMY_CONTACT_CHANGE_SUGGESTIONS: Record<string, ContactChangeSuggestion> = {
  "1": {
    id: "1",
    kind: "COMPANY_CHANGED",
    status: "pending",
    contactId: "c|ddb|preview|jane",
    snapshot: {
      personName: "Jane Doe",
      fromEmail: "jane@acme.com",
      toEmail: "jane@globex.com",
      fromTitle: "Director of Sales",
      toTitle: "VP Sales",
      fromCompany: "Acme",
      toCompany: "Globex",
      fromCompanyDomain: "acme.com",
      toCompanyDomain: "globex.com",
      fromStartDate: "2019-03-01",
      toStartDate: "2026-08-01",
      linkedinUrl: "linkedin.com/in/jane-doe",
    },
    availableModes: ["CREATE_NEW", "LINK_EXISTING", "MOVE", "TITLE_ONLY"],
    acceptMode: null,
    actedByUserId: null,
    actedByName: null,
    actedTs: null,
    resolvedContactId: null,
    dismissedByViewer: false,
    createTs: "2026-10-12T06:17:00Z",
  },
  "2": {
    id: "2",
    kind: "TITLE_CHANGED",
    status: "accepted",
    contactId: "c|ddb|preview|sam",
    snapshot: {
      personName: "Sam Lee",
      fromTitle: "Account Executive",
      toTitle: "Sales Manager",
      fromCompany: "Initech",
      toCompany: "Initech",
    },
    availableModes: ["TITLE_ONLY"],
    acceptMode: "TITLE_ONLY",
    actedByUserId: 99,
    actedByName: "Alex Kim",
    actedTs: "2026-10-12T09:40:00Z",
    resolvedContactId: "c|ddb|preview|sam",
    dismissedByViewer: false,
    createTs: "2026-10-11T06:17:00Z",
  },
};

export const DUMMY_CONTACT_CHANGE_IMPACT: ContactChangeImpact = {
  engagementCount: 17,
  dealNames: ["Acme renewal", "Acme expansion"],
  dealCount: 2,
  existingContactId: null,
  existingContactName: null,
  accountMatch: "none",
  accountCandidates: [],
  syncedTo: [],
};
